<template>
    <span>
        <v-card-text class="pb-0">
        <v-form ref="arrivalCertificationForm">
            <v-layout class="px-4 pt-2" row wrap>
<!--                 <v-flex xs12>-->
<!--                    <v-alert-->
<!--                            type="info"-->
<!--                    >-->
<!--                      <b>FOR ARRIVAL OR DEPARTURE CERTIFICATION</b>-->
<!--                    </v-alert>-->
<!--                    </v-flex>-->
                <v-flex xs12>
                    <v-alert
                            outlined
                            type="info"
                            v-if="arrival_departure_certification_cost && arrivalDepartureCertification.type"
                    >
                        Your {{ arrivalDepartureCertification.type.toLowerCase() }} certification cost will be <strong>USD($)
                        {{arrival_departure_certification_cost}}</strong>
                    </v-alert>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete
                            :items="['Arrival','Departure']"
                            :rules=[rules.required]
                            class="pr-2"
                            item-text="country_name"
                            item-value="id"
                            label="Certification type *"
                            min="0"
                            outlined
                            v-model="arrivalDepartureCertification.type"
                    />
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete
                            :items="countries"
                            :label="arrival_departure_label.country_name?arrival_departure_label.country_name:'Country Arrived From or Departed To *'"
                            :rules=[rules.required]
                            item-text="country_name"
                            item-value="id"
                            min="0"
                            outlined
                            v-model="arrivalDepartureCertification.country"
                    />
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete
                            :items="offices"
                            :label="arrival_departure_label.office_name?arrival_departure_label.office_name:'Port Arrived From or Departed Through *'"
                            :rules=[rules.required]
                            class="pl-2"
                            item-text="name"
                            item-value="id"
                            min="0"
                            outlined
                            v-model="arrivalDepartureCertification.office"
                    />
                </v-flex>

                <v-flex class="pl-3 pr-5" xs4>
                    <new-date-picker
                            :label="arrival_departure_label.arrival_departure_date?arrival_departure_label.arrival_departure_date:'Date of Arrival/Departure *'"
                            v-model="arrivalDepartureCertification.date"

                    />
                </v-flex>
                <v-flex xs4>
                    <v-combobox
                            :items="reasons"
                            :label="$vuetify.lang.t('$vuetify.purpose_of_visit')+' *'"
                            :rules="[rules.required]"
                            outlined
                            v-model="arrivalDepartureCertification.purpose_of_visit"
                    />
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete
                            :items="reason_for_certification"
                            :label="$vuetify.lang.t('$vuetify.reason_for_certification')"
                            :rules=[rules.required]
                            class="pl-2"
                            outlined
                            v-model="arrivalDepartureCertification.reason_for_certification"
                    />
                </v-flex>
            </v-layout>
        </v-form>
    </v-card-text>
        <v-card-actions class="d-flex justify-end">
            <v-btn @click="back"
                   color="error"
                   large>
            {{$vuetify.lang.t('$vuetify.back') }}
        </v-btn>
        <v-btn @click="submitArrivalCertification"
               class="mr-3"
               color="primary"
               large>
            {{$vuetify.lang.t('$vuetify.proceed') }}
        </v-btn>
    </v-card-actions>
   </span>
</template>

<script>
    import FileInput from "../../components/FileInput";
    import {validationMixin} from "../../mixins/validationMixin";
    import {mapActions, mapGetters} from "vuex";
    import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";
    import NewDatePicker from "../../components/DatePickerNew";

    export default {
        name: "ArrivalCertificationForm",
        props: ['offices', 'countries'],
        mixins: [validationMixin],
        components: {
            NewDatePicker,
            FileInput
        },
        data() {
            return {
                reasons: [],
                reason_for_certification: []
            }
        },
        computed: {
            ...mapGetters('VisaSingle', ['extendConvertVisaDetail', 'purposeAutoCompletes', 'arrivalDepartureCertification']),
            arrival_departure_certification_cost() {
                return this.extendConvertVisaDetail.arrival_departure_certification_cost;
            },
            arrival_departure_label() {
                let country_name = '';
                let office_name = '';
                let arrival_departure_date = '';
                let {type} = this.arrivalDepartureCertification;
                if (type !== undefined) {
                    type = type.toLowerCase();
                    country_name = type === 'arrival' ? 'Country arrived from *' : 'Country departed to *';
                    office_name = type === 'arrival' ? 'Arrival Point *' : 'Departure Point *';
                    arrival_departure_date = type === 'arrival' ? 'Arrived date *' : 'Departure date *';
                }
                return {
                    country_name,
                    office_name,
                    arrival_departure_date
                }
            },
        },
        methods: {
            ...mapActions('DynamicValues', ['fetchDynamicValues']),
            submitArrivalCertification() {
                if (this.$refs.arrivalCertificationForm.validate()) {
                    this.arrivalDepartureCertification.type = this.arrivalDepartureCertification.type.toLowerCase();
                    this.arrivalDepartureCertification.cost = this.arrival_departure_certification_cost;
                    this.$router.push({
                        name: 'ArrivalDepartureCertificationConfirm'
                    })
                }
            },
          back() {
            this.$router.go(-1);
          },
        },
        mounted() {
            fetchDynamicValues('PurposeOfVisa').then((data) => {
                this.reasons = data;
            });
            fetchDynamicValues('ReasonForCertification').then((data) => {
                this.reason_for_certification = data;
            })
        },
        backBtnClicked() {
            this.$router.go(-1);
        }
    }
</script>
